import React from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../dux/'
import { questionNav } from '../../../utils/questionNav'
import Button from '../../../../../shared/components/Button/Button'
import './Footer.scss'

const Footer = ({ currentQuestion, currentError, currentIndex, questionOrder }) => {
  const value = useSelector(state => state.questions[currentQuestion])
  const reasonForAppt = useSelector(state => state.questions.reasonFor)
  const dispatch = useDispatch()
  const toggleLoader = () => dispatch(actions.toggleLoader())
  const setCurrentError = (error, slideDirection) => (
    dispatch(actions.setCurrentError(error, slideDirection))
  )
  const setCurrentQuestion = (question, slideDirection) => (
    dispatch(actions.setCurrentQuestion(question, slideDirection))
  )

  const handleNext = () => {
    let appointmentForm
    let next
    if (value === undefined) return null

    if (currentQuestion === 'driveTime') { // Drive Time needs previous question data
      next = questionNav(currentQuestion, value, questionOrder[currentIndex + 1], reasonForAppt)
    } else {
      next = questionNav(currentQuestion, value, questionOrder[currentIndex + 1])
    }

    if (questionOrder.indexOf(next) >= 0) { // Is Question
      return setCurrentQuestion(next, 'next')
    }

    if (next !== 'appointmentForm' && next !== 'jeffVetAppointment') { // Is Error
      return setCurrentError(next, 'back')
    }

    // ReDirect to Appointment Form(s)
    toggleLoader()
    appointmentForm = process.env.NODE_ENV !== 'production' ? `http://forge.jefferson.edu:8300/?refUrl=${window.location.origin}` : `http://appointments.jefferson.edu/?refUrl=${window.location.origin}`
    appointmentForm += next === 'appointmentForm' ? '&isVet=false' : '&isVet=true'
    // Remove Chatbot
    appointmentForm += '&at_preview_token=1ocrMDlbuCaRcHi6qsEf34sfdKGAJyg5DsJ3XxNj67A%3D&at_preview_index=1_1&at_preview_listed_activities_only=true'

    ReactGA.event({
      category: 'Appt Request',
      action: 'Redirect to Form',
      label: next === 'appointmentForm' ? '&isVet=false' : 'isVet=true'
    })

    return setTimeout(() => { window.location = appointmentForm }, 1000)
  }

  const handleBack = () => {
    if (currentError !== undefined) {
      return setCurrentError(undefined, 'next')
    }
    return setCurrentQuestion(questionOrder[currentIndex - 1], 'back')
  }


  return (
    <div className="footer-container container">
      {currentIndex !== 0 || currentError !== undefined ? (
        <div className="footer-btn-container left">
          <Button
            className="footer-btn"
            color="blue-outline"
            onClick={handleBack}
          >Back</Button>
        </div>
      ) : ''}
      {currentError === undefined ? (
        <div className="footer-btn-container right">
          <Button
            className="footer-btn"
            color="blue-fill"
            disabled={value === undefined || value.length === 0}
            onClick={handleNext}
          >Next</Button>
        </div>
      ) : ''}
    </div>
  )
}

Footer.propTypes = {
  currentQuestion: PropTypes.string.isRequired,
  currentError: PropTypes.string,
  currentIndex: PropTypes.number.isRequired,
  questionOrder: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default Footer
